import React, { useEffect, useMemo, useState } from 'react';

const IFRAME_LOAD_TIMEOUT_MS = 20000;

function normalizeArticleUrl(raw) {
  const trimmed = String(raw || '').trim();
  if (!trimmed) return null;
  try {
    const parsed = new URL(trimmed);
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return null;
    return parsed.toString();
  } catch {
    return null;
  }
}

export default function NewsArticleIframe({
  url,
  title = 'Article',
  showFallback = true,
}) {
  const embedUrl = useMemo(() => normalizeArticleUrl(url), [url]);
  const [iframeLoading, setIframeLoading] = useState(Boolean(embedUrl));

  useEffect(() => {
    if (!embedUrl) {
      setIframeLoading(false);
      return undefined;
    }
    setIframeLoading(true);
    const timeoutId = window.setTimeout(() => {
      setIframeLoading(false);
    }, IFRAME_LOAD_TIMEOUT_MS);
    return () => window.clearTimeout(timeoutId);
  }, [embedUrl]);

  if (!embedUrl) {
    return (
      <div className="mi-news-iframe-empty report-card">
        <p>No article URL is available for this item.</p>
      </div>
    );
  }

  return (
    <div className="mi-news-iframe-panel">
      <div className="mi-news-iframe-frame">
        {iframeLoading ? (
          <div
            className="mi-news-iframe-loading"
            aria-live="polite"
            aria-busy="true"
          >
            <div className="mi-news-iframe-loading__spinner" aria-hidden="true" />
            <p className="mi-news-iframe-loading__text">Loading article…</p>
          </div>
        ) : null}
        <iframe
          className={`mi-news-iframe${iframeLoading ? ' mi-news-iframe--loading' : ''}`}
          src={embedUrl}
          title={title}
          referrerPolicy="no-referrer-when-downgrade"
          sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
          onLoad={() => setIframeLoading(false)}
          onError={() => setIframeLoading(false)}
        />
      </div>
      {showFallback ? (
        <p className="mi-news-iframe-fallback">
          If the page stays blank, the publisher may block embedded views.{' '}
          <a href={embedUrl} target="_blank" rel="noopener noreferrer">
            Open on source site
          </a>
        </p>
      ) : null}
    </div>
  );
}
